module.exports = __webpack_public_path__ + "media/fonts/gotham-book-webfont-790fb2818303bcd53f2db2aceab5a766.woff2";